import { EditOutlined } from '@mui/icons-material';
import { Avatar, Box, Chip, Container } from '@mui/material';
import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import MicrospecDataTable from '../../../MicrospecDynamicUI/Components/DataTable/MicrospecFirestoreDataTable';

const ROLE_CONFIG = {
  admin: { label: 'مدير', color: 'error' },
  normal: { label: 'عادي', color: 'primary' },
};

const ManageUsers = () => {
  const navigate = useNavigate();

  const onDataLoad = useCallback((rows) => {
    return rows.map((row) => ({
      ...row,
      full_name: `${row.first_name || ''} ${row.last_name || ''}`.trim() || '—',
    }));
  }, []);

  const columns = useMemo(
    () => [
      {
        field: 'full_name',
        headerName: 'الاسم',
        minWidth: 180,
        render: (value, row) => (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Avatar
              src={row.photo_url || ''}
              sx={{ width: 32, height: 32, bgcolor: 'primary.main', fontSize: '0.75rem' }}
            >
              {!row.photo_url &&
                `${row.first_name?.[0] || ''}${row.last_name?.[0] || ''}`.toUpperCase()}
            </Avatar>
            <span>{value}</span>
          </Box>
        ),
      },
      {
        field: 'email',
        headerName: 'البريد الإلكتروني',
        minWidth: 220,
        render: (value) => (
          <span dir="ltr" style={{ unicodeBidi: 'embed' }}>
            {value || '—'}
          </span>
        ),
      },
      {
        field: 'roles',
        headerName: 'الصلاحيات',
        minWidth: 180,
        render: (value) => {
          const rolesList = Array.isArray(value) ? value : [];
          if (rolesList.length === 0) {
            return <Chip component="span" size="small" label="بدون صلاحيات" variant="outlined" />;
          }
          return (
            <Box component="span" sx={{ display: 'inline-flex', gap: 0.5, flexWrap: 'wrap' }}>
              {rolesList.map((role) => {
                const cfg = ROLE_CONFIG[role] || { label: role, color: 'default' };
                return (
                  <Chip
                    component="span"
                    key={role}
                    size="small"
                    label={cfg.label}
                    color={cfg.color}
                    variant="outlined"
                  />
                );
              })}
            </Box>
          );
        },
      },
    ],
    []
  );

  const actions = useMemo(
    () => [
      {
        icon: <EditOutlined fontSize="small" />,
        label: 'تعديل الصلاحيات',
        onClick: (row) => navigate(`/admin/users/edit/${row.id}`),
      },
    ],
    [navigate]
  );

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <MicrospecDataTable
        collection="users"
        columns={columns}
        onDataLoad={onDataLoad}
        actions={actions}
        title={{ type: 'Literal', text: 'إدارة المستخدمين' }}
        subtitle={{ type: 'Literal', text: 'عرض جميع المستخدمين المسجلين وإدارة صلاحياتهم' }}
        searchable
        refreshable
        emptyMessage="لا يوجد مستخدمون مسجلون"
        pageSize={15}
        onRowClick={(row) => navigate(`/admin/users/edit/${row.id}`)}
      />
    </Container>
  );
};

export default ManageUsers;
